import { Column, FlexBox, Icon, IconNames, Text } from '@dixa/lib-shared-habla';
import { memo } from 'react';

import { ContactItem, ContactItemProps } from '../contactItem/contactItem';

import { useBreakpointValue } from 'utils/mediaQuery';
import styles from './contactItems.module.scss';

export type ContactItemsProps = {
  /** The section title. */
  title: string;
  /** The section title. */
  icon: IconNames;
  /** The contact items to display. */
  items: ContactItemProps[];
};

export const ContactItems = memo(function ContactItems({
  title,
  icon,
  items,
}: ContactItemsProps): JSX.Element {
  const isSmallScreen = useBreakpointValue({ base: true, md: false });
  return (
    <Column.Row noHorizontalPadding>
      <FlexBox flexDirection={isSmallScreen ? 'column' : 'row'}>
        <FlexBox gap="200" minWidth="120px" height="32px" alignItems="center">
          <Icon name={icon} />{' '}
          <Text.Paragraph variant="1">{title}</Text.Paragraph>
        </FlexBox>

        <ul className={styles.contactItems}>
          {items.map((item, index) => (
            <ContactItem key={index} {...item} />
          ))}
        </ul>
      </FlexBox>
    </Column.Row>
  );
});
